
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import HttpService from "@/service";
import 'lib-flexible'


import i18n from "@/locale"; //需要放在前面，确保国际化优先挂载
// 挂载全局
Vue.prototype.$http = new HttpService(); // ajax请求方法
Vue.prototype.$locale = i18n; //国际化

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
